import moment from 'moment-timezone';
import { map } from 'lodash';
import { withRouter } from 'react-router';
import {
  compose,
  withState,
  withProps,
  branch,
  renderComponent,
  renderNothing,
  withPropsOnChange,
  withHandlers,
} from 'recompose';

import { getBrandReservation, getReservation } from '../../reservation/actions';
import { formatDuration } from '../../utils/helpers';
import Loader from '../../components/Loader';
import { getAppLinks, getShopAddress } from '../utils';
import withExtensionContextConsumer from './withExtensionContextConsumer';
import { prependLocationPrefix } from '../../utils/routes';

const getDate = (appt) => {
  const timezone = appt.shop.timezone;
  const date = moment.utc(appt.dateTime).tz(timezone).format('ddd, MMM Do');
  const startTime = moment.utc(appt.dateTime).tz(timezone).format('h:mm A');
  return `${date}, ${startTime}`;
};

const getDaysUntilDateCopy = (nowMoment, dateMoment) => {
  const startToday = nowMoment.clone().startOf('day');
  const endToday = nowMoment.clone().endOf('day');
  const startTomorrow = nowMoment.clone().add(1, 'day').startOf('day');
  const endTomorrow = nowMoment.clone().add(1, 'day').endOf('day');
  const startTarget = dateMoment.clone().startOf('day');
  const numberOfDays = startTarget.diff(startToday, 'days');
  const date = dateMoment.format('MM/DD/YYYY');
  const time = dateMoment.format('h:mma');

  if (dateMoment.isBetween(startToday, endToday) || numberOfDays === 0) return `today at ${time}`;
  if (dateMoment.isBetween(startTomorrow, endTomorrow) || numberOfDays === 1) return `tomorrow at ${time}`;
  if (numberOfDays <= 14) return `in ${numberOfDays} days`;
  if (numberOfDays === 15) return 'in 2 weeks and a day';
  if (numberOfDays >= 16 && numberOfDays < 21) {
    const remainder = numberOfDays - 14;
    return `in 2 weeks and ${remainder} days`;
  }
  if (numberOfDays === 21) return 'in 3 weeks';
  if (numberOfDays === 22) return 'in 3 weeks and 1 day';
  if (numberOfDays >= 23 && numberOfDays < 28) {
    const remainder = numberOfDays - 21;
    return `in 3 weeks and ${remainder} days`;
  }
  if (numberOfDays >= 28 && numberOfDays < 60) return 'in a month or so';
  if (numberOfDays >= 60 && numberOfDays < 90) return 'in a couple of months';
  if (numberOfDays >= 90 && numberOfDays < 120) return 'in 3 months or so';
  if (numberOfDays >= 120) return `on ${date}`;

  return '';
};

const getDateShort = (appointment) => {
  const { timezone } = appointment.shop;
  const now = moment.utc().tz(timezone);
  const date = moment.utc(appointment.dateTime).tz(timezone);

  return getDaysUntilDateCopy(now, date);
};

export default compose(
  withRouter,
  withState('busy', 'setBusy', true),
  withState('appointment', 'setAppointment', null),
  withExtensionContextConsumer,
  withHandlers({
    fetchReservation: props => () => {
      const { confirmationCode, brandRoute } = props.params;
      try {
        let reservationCall;
        if (brandRoute) {
          reservationCall = getBrandReservation(props.extension.brandId, confirmationCode);
        } else {
          reservationCall = getReservation(confirmationCode);
        }
        reservationCall.then((reservation) => {
          const appts = [...reservation.pastAppointments, ...reservation.upcomingAppointments];
          const appt = appts.find(a => a.confirmationCode === confirmationCode);
          props.setAppointment(appt || reservation.appointment);
          props.setBusy(false);
        });
      } catch (e) {
        props.setBusy(false);
      }
    },
  }),
  withPropsOnChange(
    ['extension'],
    async (props) => {
      const { brandRoute } = props.params;
      if (brandRoute && !props.extension) {
        props.setBusy(false);
        return;
      }
      await props.fetchReservation();
    }
  ),
  branch(
    props => props.busy,
    renderComponent(Loader),
  ),
  branch(
    props => !props.appointment,
    renderNothing,
  ),
  withProps(({ appointment: appt, params }) => (
    {
      appointment: appt,
      shop: appt.shop,
      confirmationCode: appt.confirmationCode,
      customer: appt.customer,
      barber: appt.barber,
      service: map(appt.appointment_service, 'name').join(', '),
      date: getDate(appt),
      dateShort: getDateShort(appt),
      address: getShopAddress(appt.shop),
      duration: formatDuration(appt.duration),
      reservationLink: prependLocationPrefix(`/view-reservation/${appt.id}`),
      appointmentNote: appt.customerNotes,
      total: appt.totalWithTip,
      tip: appt.tipAmount,
      ...getAppLinks(params.brandRoute, params.confirmationCode),
      squireInfoClassName: appt.shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15',
    }
  )),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withAppointmentNotification.js